<template>
    <div class="search-config-main">
        <div class="opera-tit-btn">
            <div class="opera-btn">
                 <el-button type="primary" @click="subSearchField">保存配置</el-button>
            </div>
        </div>
       <div class="opera-field">
           <el-transfer
             v-model="value"
             :titles="['字段列表', '已选字段']"
             :data="data">
           </el-transfer>
       </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import {getModelFormReportList, getFormFieldListByIds} from '@/data-model';
export default{
    props: {
        moduleObj: {
            type: Object
        }
    },
    data () {
        return {
            value: [],
            data: [],
            conditionFields: [],
            loadtimeSearch: '',
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            formPage: {
                currentPage: 1, // 当前页码
                pageSize: 3, // 每页条数
                totalPageNum: 0 // 总页数
            }
        };
    },
    created () {
        this.initField();
    },
    methods: {
        buildData (conditionFields) {
            this.data = [];
            let valueIds = [];
            if (this.moduleObj.showSearchList && this.moduleObj.showSearchList.length > 0) {
                let valArray = cloneDeep(this.moduleObj.showSearchList);
                for (let j = 0; j < valArray.length; j++) {
                    let cur = valArray[j];
                    valueIds.push(cur.key);
                }
                this.value = valueIds;
            }
            for (let i = 0; i < conditionFields.length; i++) {
                let current = conditionFields[i];
                let curConfig = current.options.config;
                let type = curConfig.type;
                if (type !== 'link' && type !== 'file' && type !== 'image') {
                    let item = {label: current.name, key: current.id, obj: current};
                    this.data.push(item);
                }
            }
        },
        initField () {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let moduleSearchObj = this.moduleObj.moduleSearchObj;
            if (moduleSearchObj.conditionFields.length > 0) { // 有数据
                this.buildData(moduleSearchObj.conditionFields);
            } else {
                let param = {dataModelId: moduleSearchObj.dataModelId, dataFormId: moduleSearchObj.dataFormId};
                this.renderFormList(param, true);
            }
            loading.close();
        },
        async renderFormList (model, isInitSearch) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            let tcln = [];
            if (formData.otherData && formData.otherData.tableColumns) {
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        tcln.push(item);
                    }
                });
            }
            this.refreshSearchConditon(tcln);
            loading.close();
        },
        async refreshSearchConditon (columns) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let rtArr = [];
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            loading.close();
            let cfs = await getFormFieldListByIds(idArr.join(','));
            const loading2 = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        rtArr.push(cfs[i]);
                    }
                }
            }
            this.conditionFields = rtArr;
            this.showConditionFields = true;
            this.loadtimeSearch = new Date().getTime();
            loading2.close();
            this.buildData(this.conditionFields);
        },
        subSearchField () {
            let fieldArray = [];
            if (this.data.length > 0) {
                for (let i = 0; i < this.data.length; i++) {
                    let cur = this.data[i];
                    if (this.value.indexOf(cur.key) !== -1) {
                        fieldArray.push(cur);
                    }
                }
            }
            this.$emit('configSearchTool', fieldArray);
        }
    }
};
</script>

<style lang="less">
    .search-config-main{
        height: 99%;
        width: 96%;
        top: 0vh;
        overflow: auto;
        position: absolute;
        .opera-field{
            position: relative;
            left: 30%;
            .el-transfer-panel__list{
                height: 500px;
            }
        }
        .opera-tit-btn{
            height:8vh;
            line-height: 8vh;
            .opera-btn{
                text-align: right;
                margin-right:20px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/SearchTooConfig.vue